import {Separator} from 'platform/components';
import {Box, VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useState} from 'react';

import {EntityResourceIds} from '@dms/api/shared';
import {
  CommunicationChannelChips,
  CommunicationThreadComposer,
  CommunicationThreadFeed,
  CommunicationThreadScope,
  CommunicationThreadScopeChips,
  useCommunicationThread,
  useThreadCallActions,
} from '@dms/shared';

interface CommunicationThreadTabProps {
  customerId: string;
  recordId: string;
  resourceId: EntityResourceIds;
}

export function CommunicationThreadTab(props: CommunicationThreadTabProps) {
  const [threadScope, setThreadScope] = useState<CommunicationThreadScope>('record');

  const threadArgs = match(threadScope)
    .with('customer', () => ({customerId: props.customerId}))
    .with('record', () => ({
      customerId: props.customerId,
      recordId: props.recordId,
      resourceId: props.resourceId,
    }))
    .exhaustive();

  const {activeFilter, setActiveFilter, filterCounts, groups, isLoading, isError} =
    useCommunicationThread(threadArgs);
  const {callPairing, canEditCallNotes, canOpenCall, canListenRecording} = useThreadCallActions({
    resourceId: props.resourceId,
    recordId: props.recordId,
  });

  return (
    <VStack height="100%">
      <Box
        paddingHorizontal={4}
        paddingVertical={3}
        backgroundColor="general.white"
        borderBottom="1px solid"
        borderColor="general.separator"
      >
        <VStack spacing={3}>
          <CommunicationThreadScopeChips value={threadScope} onChange={setThreadScope} />
          <Separator spacing={0} />
          <CommunicationChannelChips
            filterCounts={filterCounts}
            activeFilter={activeFilter}
            onFilterChange={setActiveFilter}
          />
        </VStack>
      </Box>

      <Box flex={1} overflow="auto" minHeight={0}>
        <Box paddingHorizontal={4} paddingVertical={4}>
          <CommunicationThreadFeed
            groups={groups}
            isLoading={isLoading}
            isError={isError}
            isBasicMessagingOnly={props.resourceId === EntityResourceIds.directSale}
            callPairing={callPairing}
            canEditCallNotes={canEditCallNotes}
            canOpenCall={canOpenCall}
            canListenRecording={canListenRecording}
          />
        </Box>
      </Box>

      <Box
        paddingHorizontal={4}
        paddingVertical={3}
        backgroundColor="general.white"
        borderTop="1px solid"
        borderColor="general.separator"
      >
        <CommunicationThreadComposer
          customerId={props.customerId}
          recordId={props.recordId}
          resourceId={props.resourceId}
        />
      </Box>
    </VStack>
  );
}
